var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginArt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    width: 1000,
    height: 1000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8703118_3974105") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { opacity: 0;fill: #ffffff } \n\t\t.s1 { fill: #7b70ee } \n\t\t.s2 { fill: #d5cbfb } \n\t\t.s3 { fill: #1c1c84 } \n\t\t.s4 { fill: #2525ad } \n\t\t.s5 { fill: #f0c64b } \n\t\t.s6 { fill: #d8a32b } \n\t\t.s7 { fill: #0c0c5b } \n\t\t.s8 { fill: #fff6dc } \n\t\t.s9 { fill: #ffffff } \n\t\t.s10 { fill: #f4e7bd } \n\t\t.s11 { fill: #f5f5ff } \n\t\t.s12 { fill: none;stroke: #7b70ee;stroke-miterlimit:10;stroke-width: 4.3 } \n\t\t.s13 { fill: none;stroke: #2525ad;stroke-miterlimit:10;stroke-width: 3.8 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1000 1000h-1000v-1000h1000z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m720.9 676h-423.5c-3.9 0-7.2-3.3-7.2-7.3v-271.7c0-4 3.3-7.2 7.2-7.2h423.5c4 0 7.3 3.2 7.3 7.2v271.7c0 4-3.3 7.3-7.3 7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m717.3 648.2h-416.2v-237.6h416.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m511.8 399.3c0 1.5-1.2 2.7-2.6 2.7-1.5 0-2.6-1.2-2.6-2.7 0-1.4 1.1-2.6 2.6-2.6 1.4 0 2.6 1.2 2.6 2.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m787.1 769.3l-53.8-85.6c-3-4.8-8.3-7.7-14-7.7h-219.5-12.1-188.6c-5.7 0-11 2.9-14 7.7l-53.8 85.6c-1.5 2.5-2.1 5.3-1.6 8.1h559c0.5-2.8-0.1-5.6-1.6-8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m229.7 777.4q0.1 0.9 0.4 1.7l0.8 2.6c1.6 4.7 6 7.9 11 7.9h245.8 12.1 276.7c4.9 0 9.3-3.2 10.9-7.9l0.9-2.6q0.2-0.8 0.4-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m319.4 718.2l2.6-5.8h-13l-2.8 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m342.2 701.8l1.3-3 1.2-2.8h-12.6l-2.6 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m324.7 712.4l-2.7 5.8h13.2l2.4-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m323.1 710l2.6-5.8h-12.7l-2.8 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m587 696l1.4 5.8h11.2l-1.6-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m387 712.4l-1.8 5.8h13.3l1.7-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m371.5 712.4l-2.1 5.8h13.3l1.8-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m355.9 712.4l-2.3 5.8h13.2l2.1-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m340.3 712.4l-2.5 5.8h13.2l2.3-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m600.5 696l1.6 5.8h10.4l-1.6-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m431.8 704.2l-1.4 5.8h10.5l1.3-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m545.5 696l1 5.8h12.1l-1.1-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m429.9 701.8l1.5-5.8h-11l-1.6 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m416.2 701.8l1.7-5.8h-10.4l-1.7 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m442.7 701.8l1.3-5.8h-10.1l-1.5 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m613.4 696l1.7 5.8h13l-1.8-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m377.4 696l-2.1 5.8h12.4l0.9-3 0.9-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m372.7 701.8l2.1-5.8h-12.3l-2.3 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m347.3 696l-2.5 5.8h12.8l1.2-3 1.1-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m574.4 696l1.3 5.8h10.2l-1.4-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m560 696l1.1 5.8h12.1l-1.3-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m403.3 701.8l1.7-5.8h-13l-1.7 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m418.5 693.6l1.5-5.4h-10.2l-1.6 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m405.7 693.6l1.6-5.4h-12.9l-1.6 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m531.3 696l0.7 5.8h12l-0.9-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m458.9 693.6l1.1-5.4h-11.8l-1.2 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m444.5 693.6l1.2-5.4h-9.8l-1.4 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m432 693.6l1.3-5.4h-10.7l-1.5 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m673.7 696l2.5 5.8h12.7l-2.6-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m345.7 693.6l2.3-5.4h-12.3l-2.5 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m360.9 693.6l2.1-5.4h-12.4l-2.2 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m390.2 693.6l1.7-5.4h-11.7l-1.9 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m688.9 696l2.7 5.8h12.6l-2.7-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m375.7 693.6l1.9-5.4h-12l-2.1 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m628.9 696l1.8 5.8h12.3l-2-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m457.7 712.4l-1.2 5.8h12.6l0.9-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m402.7 712.4l-1.7 5.8h10.7l1.6-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m442.8 712.4l-1.3 5.8h12.5l1.2-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m415.8 712.4l-1.6 5.8h11.6l1.4-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m429.8 712.4l-1.5 5.8h10.7l1.3-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m475.3 696l-1 5.8h12.1l0.7-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m473.3 693.6l0.9-5.4h-11.8l-1 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m459.3 704.2l-1.2 5.8h12.4l0.9-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m658.5 696l2.3 5.8h12.7l-2.4-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m485.5 710l0.6-5.8h-12.2l-1 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m643.6 696l2 5.8h12.6l-2.3-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m326.8 701.8l2.6-5.8h-12.5l-2.8 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m604.2 718.2l-1.6-5.8h-11.5l1.5 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m418.1 704.2l-1.6 5.8h11.4l1.4-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m625.6 693.6l-1.6-5.4h-12.9l1.6 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m654.9 693.6l-2.2-5.4h-12l2 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m640.1 693.6l-1.9-5.4h-11.7l1.7 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m571.3 693.6l-1.2-5.4h-11.7l1.1 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m557 693.6l-1.1-5.4h-11.7l0.9 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m670 693.6l-2.3-5.4h-12.3l2.1 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m597.3 693.6l-1.5-5.4h-10.8l1.4 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m583.9 693.6l-1.4-5.4h-9.9l1.2 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m590.1 718.2l-1.5-5.8h-10.5l1.3 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m680.5 718.2l-2.4-5.8h-13l2.3 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m648.9 718.2l-2-5.8h-13l1.8 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m712.1 718.2l-2.7-5.8h-13l2.6 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m696.3 718.2l-2.6-5.8h-13l2.5 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m664.7 718.2l-2.3-5.8h-12.9l2 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m576.9 718.2l-1.3-5.8h-12.4l1.1 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m685.1 693.6l-2.4-5.4h-12.3l2.3 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m706.9 701.8h11.7l-3.2-5.8h-11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m617.3 718.2l-1.7-5.8h-10.5l1.6 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m700.3 693.6l-2.6-5.4h-12.3l2.4 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m633.1 718.2l-1.7-5.8h-13.2l1.7 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m714 693.6l-3-5.4h-10.6l2.6 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m610.1 693.6l-1.5-5.4h-10.3l1.5 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m531.4 718.2l-0.7-5.8h-12.6l0.2 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m343.8 704.2l-1.3 3-1.2 2.8h13l2.3-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m545.4 710l-0.9-5.8h-12.3l0.7 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m338.7 710l2.5-5.8h-12.8l-1.4 3.1-1.2 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m446.5 696l-1.3 5.8h12.1l1.1-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m460.9 696l-1.1 5.8h12.1l0.9-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m389.5 704.2l-1.7 5.8h13.1l1.7-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m359.2 704.2l-2.3 5.8h12.9l2.1-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m405.1 704.2l-1.7 5.8h10.6l1.6-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m517.8 704.2l0.2 5.8h12.5l-0.7-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m374.5 704.2l-2.1 5.8h12.8l1.8-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m528.5 693.6l-0.6-5.4h-10.8l0.2 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m561.8 718.2l-1.1-5.8h-12.4l1 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m503.7 688.2l-0.2 5.4h11.4l-0.2-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m503.4 696l-0.3 5.8h12.1l-0.2-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m529.5 701.8l-0.7-5.8h-11.4l0.3 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m542.6 693.6l-0.9-5.4h-11.3l0.6 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m503 704.2l-0.2 5.8h12.8l-0.3-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m502.7 712.4l-0.2 5.8h13.4l-0.2-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m501 693.6l0.2-5.4h-10.8l-0.6 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m475.7 693.6h11.7l0.6-5.4h-11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m560.2 710l-1.1-5.8h-12.2l1 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m444.7 704.2l-1.3 5.8h12.3l1.1-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m289.1 720.6l-2.9 5.1h13.7l2.5-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m614.9 710l-1.6-5.8h-10.5l1.6 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m607.4 720.6l1.4 5.1h10.7l-1.5-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m588 710l-1.5-5.8h-10.3l1.3 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m500 718.2l0.3-5.8h-12.7l-0.6 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m652.4 720.6l1.8 5.1h13.5l-2-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m692.6 710l-2.6-5.8h-12.8l2.5 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m668.3 720.6l2.1 5.1h13.3l-2.1-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m472.5 712.4l-1 5.8h13l0.7-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m293.7 712.4l-3.2 5.8h13l2.8-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m534.1 720.6l0.6 5.1h13.4l-0.9-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m336.8 720.6l-2.2 5.1h13.4l2-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m499.9 720.6h-13.2l-0.6 5.1h13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m677 710l-2.4-5.8h-12.8l2.3 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m305.1 720.6l-2.5 5.1h13.4l2.3-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m561.6 704.2l1.1 5.8h12.3l-1.3-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m620.6 720.6l1.5 5.1h13.3l-1.5-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m564.8 720.6l1 5.1h12.7l-1.1-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m630.6 710l-1.7-5.8h-13.1l1.7 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m646 710l-2.1-5.8h-12.5l1.8 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m549.7 720.6l0.9 5.1h12.7l-1-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m636.4 720.6l1.6 5.1h13.6l-1.8-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m303 696l-3.3 5.8h11.7l2.8-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m700.1 720.6l2.3 5.1h13.3l-2.4-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m307.4 688.2l-3 5.4h11l2.6-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m661.5 710l-2.4-5.8h-12.6l2.1 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m467.8 725.7l0.8-5.1h-115.9l-2.1 5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m579.9 720.6l1.1 5.1h10.9l-1.2-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m488.9 701.8h11.8l0.2-5.8h-11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m724.6 712.4h-12.5l6.3 13.3h13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m710.9 710h12.4l-3.3-5.8h-11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m708.2 710l-2.8-5.8h-12.7l2.6 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m483.6 725.7l0.6-5.1h-13.1l-0.8 5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m502.4 720.6l-0.2 5.1h30.1l-0.6-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m684.2 720.6l2.2 5.1h13.3l-2.3-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m601.9 710l-1.6-5.8h-11.2l1.4 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m593.2 720.6l1.3 5.1h11.7l-1.4-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m298.4 704.2l-3.3 5.8h12.4l2.8-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m330.5 693.6l2.5-5.4h-12.3l-2.6 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m320.9 720.6l-2.3 5.1h13.4l2.1-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m500.4 710l0.2-5.8h-12l-0.7 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m545.9 712.4h-12.7l0.7 5.8h12.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m585.6 768.6h-152.8c-0.7 0-1.3-0.3-1.7-0.8-0.3-0.5-0.5-1.2-0.3-1.8l9.7-31.6c0.3-0.8 1.1-1.4 2-1.4h133.4c0.9 0 1.7 0.6 1.9 1.4l9.7 31.6c0.2 0.6 0.1 1.3-0.3 1.8-0.4 0.5-1 0.8-1.6 0.8zm-143.1-33.8q-0.2 0-0.2 0.2l-9.7 31.6q-0.1 0.1 0 0.1 0 0.1 0.2 0.1h152.8q0.1 0 0.2-0.1 0 0 0-0.1l-9.7-31.6q-0.1-0.2-0.2-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m583.4 447l-166 26.2 159.6 79.9 165.3-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m417.4 473.2v3.8l159.7 83.5 165.2-28.4v-3.6l-165.3 24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m479.1 563l-2.5 16.9c0 0 68.2 54.8 164.3 27.8l1.5-13.1c-85 14.2-138.5-13.4-163.3-31.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m681.5 651.9c-8.9-7-15.2-17.4-18.2-28.4-0.2-0.8-1.3-0.5-1.4 0.2-0.2-0.3-0.6-0.3-0.9-0.2-0.2-0.5-1.1-0.8-1.5-0.1-6.1 11.8-1.3 25.2 2.7 36.9 0.4 0.9 1.4 0.4 1-0.5-3.1-9.2-6.6-19.4-4.6-29.1-1.1 12.2 3 24.7 10.4 34.4 0.5 0.7 1.4-0.1 0.8-0.8-6.7-8.8-10.2-20-9.9-31.1 0.3 4.4 0.9 8.8 2.3 12.9 2.2 6.3 5.7 12.3 9.3 17.9 0.5 0.8 1.4-0.1 0.8-0.9-3.4-5.3-6.4-11.1-8.5-17.1-0.9-2.6-1.5-5.3-1.9-8 2 8.8 6.3 17.2 12.5 23.9 0.6 0.7 1.5 0.1 0.8-0.6-6.7-7.4-10.8-16.9-12.4-26.7 2.4 9.2 7 17.8 13 25.3 0.6 0.7 1.3-0.1 0.7-0.8-5.9-7.3-9.8-15.8-12.3-24.8 3.3 9.3 7.6 18.2 15.1 24.7 0.7 0.7 1.5-0.1 0.8-0.7-5.2-4.5-8.6-10.6-11.3-16.7 3 5.3 6.6 10.3 10.8 14.8 0.6 0.7 1.2-0.4 0.5-1.1-3.6-4-6.5-8.4-9.2-13 2.8 3.8 6.1 7.2 9.8 10.2 0.8 0.6 1.6 0 0.8-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m665.9 524.1c-3.5-4.1-8.2-6.9-12.9-9.2-9.6-4.6-20.2-6.6-30.5-8.6-14.6-2.7-29.6-5.3-41.7-14.5-0.5-0.4-1-0.2-1.2 0.2q-0.1 0-0.1 0.1 0 0 0 0c-0.3 0.3-0.4 0.9 0 1.3 9 8.5 20.9 12.7 32.6 15.7 11.8 3 23.9 5 35.2 9.7q0.6 0.2 1.1 0.5c0.1 0 0.4 0.2 0.4 0.2q0.9 0.4 1.8 0.8c2.1 1.1 4.2 2.2 6.1 3.5 2.3 1.7 4.5 3.7 6 6.1 1.6 2.7 2.2 5.7 2.1 8.8 0 3.2-0.6 6.4-1.2 9.6-0.5 3.3-1 6.6-1.5 9.9-1 6.8-2 13.6-2.8 20.4-1.6 15.1-2 30.5 0.7 45.5 0.2 1.1 2.1 0.9 2-0.3-1.1-14.2 0.1-28.5 2.1-42.5 1-7.1 2.2-14 3.4-21 1.2-6.6 2.7-13.2 3.2-19.8 0.5-6-0.9-11.7-4.8-16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m659.2 625.2q0.3-0.1 0.6-0.3 0.1 0 0 0 0 0 0.1 0 0.1 0 0.2-0.1 0.6-0.2 1.2-0.2 0.1-0.1 0.3-0.1c-0.3 0 0 0 0.1 0q0.3 0 0.5 0 0.3 0 0.6 0 0.2 0.1 0.3 0.1 0.1 0 0.2 0-0.2 0-0.1 0c0.3 0 0.6 0.1 0.8-0.1 0.2-0.1 0.4-0.3 0.5-0.6 0.1-0.4-0.1-1.1-0.7-1.2-1.9-0.4-3.8-0.2-5.5 0.7-0.5 0.2-0.7 0.9-0.4 1.4 0.3 0.4 0.8 0.6 1.3 0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m659 623.2q0.3-0.1 0.6-0.2 0.1-0.1-0.1 0 0.1-0.1 0.2-0.1 0.1 0 0.2-0.1 0.6-0.1 1.2-0.2 0.1 0 0.3 0c-0.3 0 0 0 0.1-0.1q0.3 0 0.5 0 0.3 0 0.6 0.1 0.2 0 0.3 0 0.1 0 0.2 0-0.2 0-0.1 0c0.3 0.1 0.6 0.1 0.8 0 0.2-0.2 0.4-0.4 0.5-0.6 0.1-0.5-0.1-1.2-0.7-1.3-1.9-0.4-3.8-0.1-5.5 0.7-0.5 0.3-0.7 0.9-0.4 1.4 0.3 0.5 0.8 0.7 1.3 0.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m647.3 554.8l0.9-6.5-71.1 12.2-89.4-46.8-1.9 11.1 89.5 45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m575.3 569.9l-89.5-45.1-6.7 38.2c24.8 18.2 78.3 45.8 163.3 31.6l4.9-39.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m466.8 621.8c3.9 10.7-4.6 23.7-19.1 29-14.4 5.4-22.7-1.4-28.5-11.2-8.4-14.3-0.3-22 14.2-27.4 14.5-5.4 29.4-1.1 33.4 9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m322.3 504.2c0 0 35.9 37 65.3 103.3 0 0 14 36.1 23.1 45.1 0 0-7.4-8.4 3.9-21.7 8.3-9.8 20.5-15.8 33.3-16.2 7.2-0.3 14.7 1.2 18.9 7.2 0 0-47.9-56.4-79.2-105.1-12.5-19.4-18.4-35.5-21-47.8 0 0-2.3-2.7-7-5.1-17.3-8.5-37.7 3-40.7 22q-0.4 2.7-0.5 5.7c0 0-0.2 8.4 3.9 12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m410.7 652.6c0 0 15.7 18.9 51.3-3.8 0 0 22.1-14.7 11.1-40.3 0 0-22.9-17-40.9-38.6-18-21.6-40.3-51-58.8-89.9l-4.7-2.8c0 0 3.4 18.4 25.4 49.5 22 31 62.6 83 62.6 83l6.2 7.5c3.6 4.3 4.8 10.2 2.8 15.4-2.8 7.5-11 16.3-34 17.6l-14.3-22.3c0 0-13.9 11.6-6.7 24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m445.5 584.3c0 0-41.3-43-70.2-111.1 0 0-5.2-8.3-8.5-12.1 0 0 25.1 77.7 78.7 123.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m369.6 571.8c8.7-15.6 27.4-26 45.3-25.1 6.4 0.3 6.3-7.6 0-7.9-21.2-1.1-42.2 9.5-52.4 28 0 0 4 10.6 7.1 5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m305.7 600.6h-81c-10.7 0-19.5-8.8-19.5-19.5v-42.2c0-10.7 8.8-19.5 19.5-19.5h81c10.7 0 19.5 8.8 19.5 19.5v42.2c0 10.7-8.8 19.5-19.5 19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m252.3 560v-14.9l12.9 7.5 12.9 7.4-12.9 7.4-12.9 7.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m217.2 483.9h-40.6c-2.1 0-3.7-1.7-3.7-3.7 0-2.1 1.6-3.7 3.7-3.7h40.6c2 0 3.7 1.6 3.7 3.7 0 2-1.7 3.7-3.7 3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m196.9 504.9c-8.2 0-14.9-6.7-14.9-14.9v-2.4h29.7v2.4c0 8.2-6.6 14.9-14.8 14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m217.2 491.3h-40.6c-2.1 0-3.7-1.7-3.7-3.7 0-2.1 1.6-3.7 3.7-3.7h40.6c2 0 3.7 1.6 3.7 3.7 0 2-1.7 3.7-3.7 3.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m201 476.5h-2.1v-62.4c0-1.1-0.9-2-2-2-1.1 0-2 0.9-2 2v62.4h-2.1v-62.4c0-2.2 1.8-4.1 4.1-4.1 2.2 0 4.1 1.9 4.1 4.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m126.3 406.2l-1.2 6.4 18.8 3.6q0.3-3.3 1.1-6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m141.2 376.6l-4 5.2 15 11.4q1.8-2.8 3.9-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m167.4 356.6l-5.8 3 8.4 16.7q2.8-1.7 5.8-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m268.7 412.6l-1.3-6.4-18.6 3.6q0.7 3.1 1.1 6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m256.5 381.8l-3.9-5.2-14.9 11.3q2.1 2.5 3.9 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m232.2 359.6l-5.9-3-8.4 16.7q3.1 1.3 5.9 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m200.2 369.1l-0.1-19-6.6 0.1 0.2 18.9q1.6-0.1 3.2-0.1 1.7 0 3.3 0.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m859.9 801.8h-189.7v-37.4h189.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m688.6 801.8h-7.7v-37.4h7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m700 801.8h-7.6v-37.4h7.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m837.8 801.8h-7.6v-37.4h7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m849.3 801.8h-7.7v-37.4h7.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m878.2 743.5v-5.7c0-8.2-6.7-14.9-14.8-14.9h-169.1v35.4h169.1c8.1 0 14.8-6.6 14.8-14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m863.4 716.7h-170.2v3.1 3.1h170.2c8.1 0 14.8 6.7 14.8 14.9v5.7c0 8.2-6.7 14.8-14.8 14.8h-170.2v3.2 3.1h170.2c11.6 0 21-9.5 21-21.1v-5.7c0-11.7-9.4-21.1-21-21.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m866.7 733.7h-172.4v-2.8h172.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m866.7 742.2h-172.4v-2.8h172.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m866.7 750.8h-172.4v-2.9h172.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m679.8 697.9v-5.1c0-7.4 6-13.4 13.4-13.4h152.2v31.9h-152.2c-7.4 0-13.4-6-13.4-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m693.2 673.8h153.2v2.8 2.8h-153.2c-7.4 0-13.4 6-13.4 13.4v5.1c0 7.4 6 13.4 13.4 13.4h153.2v2.8 2.8h-153.2c-10.5 0-19-8.5-19-19v-5.1c0-10.5 8.5-19 19-19z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m690.2 689.1h155.2v-2.5h-155.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m690.2 696.8h155.2v-2.6h-155.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m690.2 704.5h155.2v-2.6h-155.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m373.9 276.1c7.2 0 13 5.7 13 12.6v1.9c2.6 7.4 4.2 16.9 4.2 27.4 0 10.5-1.6 20-4.2 27.4v1.9c0 6.9-5.8 12.6-13 12.6-9.5 0-17.2-18.8-17.2-41.9 0-23.1 7.7-41.9 17.2-41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m362.6 318.5c0 14.2 1.1 25.6 2.4 25.6 1.4 0 2.5-11.4 2.5-25.6 0-14.1-1.1-25.6-2.5-25.6-1.3 0-2.4 11.5-2.4 25.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m405.1 299v1.7 35.7 1.6c-0.9 9.7-9.8 18.6-21.7 21.9v-23.5-35.7-23.5c11.9 3.2 20.8 12.2 21.7 21.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m383.4 364.3c1.9 0 3.5-1.5 3.5-3.4v-84.8c0-1.8-1.6-3.4-3.5-3.4-1.9 0-3.5 1.6-3.5 3.4v84.8c0 1.9 1.6 3.4 3.5 3.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m306.5 276.1c-7.1 0-13 5.7-13 12.6v1.9c-2.6 7.4-4.2 16.9-4.2 27.4 0 10.5 1.6 20 4.2 27.4v1.9c0 6.9 5.9 12.6 13 12.6 9.5 0 17.2-18.8 17.2-41.9 0-23.1-7.7-41.9-17.2-41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m317.9 318.5c0 14.2-1.1 25.6-2.5 25.6-1.3 0-2.4-11.4-2.4-25.6 0-14.1 1.1-25.6 2.4-25.6 1.4 0 2.5 11.5 2.5 25.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m275.4 299v1.7 35.7 1.6c0.9 9.7 9.7 18.6 21.6 21.9v-23.5-35.7-23.5c-11.9 3.2-20.7 12.2-21.6 21.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m297 364.3c-1.9 0-3.5-1.5-3.5-3.4v-84.8c0-1.8 1.6-3.4 3.5-3.4 2 0 3.6 1.6 3.6 3.4v84.8c0 1.9-1.6 3.4-3.6 3.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m383.7 224.5c-7-5.8-16.2-9.5-25-11.6-9-2.2-18.4-2.8-27.6-1.7q-4.1 0.5-8.2 1.3c-1.9 0.4-4 0.7-5.7 1.5-1.8 0.9-3.6 1.8-5.4 2.7q-7.2 3.7-14.5 7.4c-2 1-1.7 3.8 0 4.8 4.5 2.7 9.6 3.1 14.7 2.3 3.5-0.6 6.8-1.9 10.2-3.1 6.1-2.1 12.7-3.1 19.1-3.2 5.7 0 11.6 0.9 16.9 3.1 7.8 3.4 17.2 5.7 25 0.9 1.4-0.8 2-3.2 0.5-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m341.4 208.1v-0.1q-0.6 0-1.2 0-0.6 0-1.2 0v0.1c-40.4 1.3-72.8 34.4-72.8 75.1v45.7c0 5 4.1 9.1 9.2 9.1v-45l-0.2-1.1c-3.1-18.3 0.9-37.3 12-52 5.2-7 12.2-13.5 21.8-18.2q0.2 0 0.3-0.1c19.5-9.5 42.4-9.5 61.8 0q0.2 0.1 0.4 0.1c9.5 4.8 16.6 11.3 21.8 18.3 11.1 14.7 15 33.7 11.9 51.9l-0.2 1.1v45c5.1 0 9.2-4.1 9.2-9.1v-45.7c0-40.7-32.4-73.8-72.8-75.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m896.3 544.2h-119.4v-172.6h119.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m883.4 400.8h-93.6v-3.8h93.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m883.4 418.3h-93.6v-3.8h93.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m883.4 435.8h-93.6v-3.8h93.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m883.4 453.4h-93.6v-3.8h93.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m883.4 470.9h-93.6v-3.8h93.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m883.4 488.4h-93.6v-3.8h93.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m883.4 528.3h-93.6v-1.1h93.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m802.6 510.6c4.8 0.9 9.6 1.1 14.5 0.7 4.4-0.4 9.2-1.2 13.3-2.9 3-1.2 6.2-4.6 4.2-7.9-1.9-3-6.5-3.3-9.5-2.6-3.6 0.8-6.7 3.2-8.9 6.1-2.1 2.9-3.7 7.1-1.1 10.2 2.4 2.9 6.7 3.5 10.2 3 1.9-0.3 3.8-0.9 5.6-1.9q1.2-0.7 2.2-1.6c0.9-0.8 1.9-1.8 3.2-2 1.5-0.2 1.8 1 2.8 1.8 0.6 0.6 1.5 0.8 2.4 0.7 1-0.1 2-0.6 3-1 1.2-0.4 2.4-0.6 3.7-0.6 5.7 0.1 11.5 0.9 17.1 1.4 1.1 0 1-0.9 0-1-4.2-0.3-8.4-1.3-12.6-1.7-2-0.1-3.9-0.4-5.9-0.2-1.8 0.1-3.3 1-5 1.4-2 0.4-2.2-1.5-3.8-2.1-1.4-0.6-2.9-0.1-4.1 0.7-1.5 1-2.7 2.2-4.2 3.1-1.7 0.9-3.7 1.5-5.7 1.6-3.2 0.2-7.9-0.8-8.6-4.6-0.6-3.4 2.2-7 4.7-9.1 2.6-2 6-3.4 9.4-2.8 1.6 0.3 3.7 1 4 2.8 0.5 2.1-1.3 3.8-3 4.6-2 0.9-4.2 1.4-6.3 1.9q-3.5 0.8-7.1 1.1c-4.7 0.4-9.4 0.6-14.1-0.2-1-0.1-1.4 1-0.4 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m936.2 476.4l-21-11.4 6.2-11.4c1.3-2.4 4.4-3.3 6.8-2l12.1 6.6c2.5 1.3 3.4 4.4 2 6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m874.1 590.8l-21-11.4 60.6-111.7 21 11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m867.4 587.1l-7.5-4.1 60.6-111.6 7.5 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m937.2 480.4l-26-14.1 2.8-5 25.9 14.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m874.1 590.8l-21-11.4-2.1 19 8.3 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m859.3 602.9l-8.3-4.5-1.4 12.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m185.9 282.5l21.5 21.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m207.8 282.5l-21.4 21.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m908.1 604.5l21.4 21.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m930 604.5l-21.5 21.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m125.4 529.2l19 19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m144.8 529.2l-19.1 19"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m115.3 371.6c0 8.6-7 15.6-15.5 15.6-8.6 0-15.6-7-15.6-15.6 0-8.5 7-15.5 15.6-15.5 8.5 0 15.5 7 15.5 15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m738.8 344.1c0 8.6-7 15.6-15.5 15.6-8.6 0-15.6-7-15.6-15.6 0-8.5 7-15.5 15.6-15.5 8.5 0 15.5 7 15.5 15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m794.1 322.5c0 2.2-1.7 3.9-3.9 3.9-2.2 0-4-1.7-4-3.9 0-2.2 1.8-4 4-4 2.2 0 3.9 1.8 3.9 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m413.4 190.8c0 2.2-1.7 4-3.9 4-2.2 0-3.9-1.8-3.9-4 0-2.1 1.7-3.9 3.9-3.9 2.2 0 3.9 1.8 3.9 3.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m271.4 691.8v55c0 30.3-24.6 55-54.9 55-26.9 0-49.3-19.4-54-45-13-0.2-23.5-10.8-23.5-23.9v-7.9c0-12.7 10-23.1 22.5-23.8v-9.4zm-109.8 57.2q-0.1-1.1-0.1-2.2v-37.9c-8.3 0.7-14.8 7.6-14.8 16.1v7.9c0 8.5 6.6 15.5 14.9 16.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m244.1 629.3c-7-3.6-16.2-1.9-21.8 3.6-1-8-8.7-14.1-16.6-15.3-8-1.2-16.2 1.6-23.2 5.6-6.8 4-13.3 9.4-16.1 16.8-2.9 7.4-1.3 16.9 5.2 21.4 2.7 1.8 6 2.3 9.2 1.8 0.4 2.5 1.4 4.9 3.1 6.9 5.4 6.6 16.7 7.3 22.8 1.3 4.7 4.2 11.9 5.2 17.6 2.6q1.8-0.9 3.4-2.2c-0.4 5.5-2.5 10.9-6 15.1 6.8-2.3 12.6-7.4 15.9-13.8 2.2-4.3 3.2-9 3-13.8 5.3-1 10.2-4.9 11.9-10.1 2.5-7.4-1.4-16.3-8.4-19.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m490.7 299.4q-0.4 0-0.9-0.1c-5.8 0-10.6 4.8-10.6 10.7 0 5.8 4.8 10.6 10.6 10.6q0.5 0 0.9-0.1c5.5-0.4 9.7-5.1 9.7-10.5 0-5.5-4.2-10.2-9.7-10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m521 316.8h-3.9l-0.4 1.3q-0.8 2.7-2.1 5.1l-0.6 1.2 2.7 2.8c1.3 1.3 2 3 2 4.8 0 1.8-0.7 3.6-2 4.9-1.3 1.3-3 2-4.8 2-1.9 0-3.6-0.7-4.9-2l-2.8-2.8-1.2 0.6q-2.4 1.3-5 2.1l-1.3 0.4v4c0 1.8-0.7 3.5-2 4.8-0.9 0.9-2.1 1.6-3.3 1.8l-0.2 0.1q-0.7 0.1-1.4 0.1c-3.8 0-6.8-3.1-6.8-6.8v-4l-1.4-0.4q-2.6-0.8-5-2.1l-1.2-0.6-2.8 2.8c-1.3 1.3-3 2-4.8 2-1.9 0-3.6-0.7-4.9-2-2.7-2.7-2.7-7.1 0-9.7l2.8-2.8-0.7-1.2q-1.2-2.4-2-5.1l-0.4-1.3h-4c-1.8 0-3.5-0.7-4.8-2-1.3-1.3-2-3-2-4.8 0-3.8 3-6.9 6.8-6.9h4l0.4-1.3q0.8-2.6 2-5l0.7-1.3-2.8-2.7c-1.3-1.3-2-3.1-2-4.9 0-1.8 0.7-3.6 2-4.9 2.7-2.6 7-2.6 9.7 0l2.8 2.8 1.2-0.6q2.4-1.3 5-2.1l1.4-0.4v-3.9c0-1.9 0.7-3.6 2-4.9 1.3-1.3 3-2 4.8-2q0.7 0 1.4 0.1c3.2 0.7 5.5 3.5 5.5 6.8v3.9l1.3 0.4q2.6 0.8 5 2.1l1.2 0.6 2.8-2.8c1.3-1.3 3-2 4.9-2 1.8 0 3.5 0.7 4.8 2 2.7 2.7 2.7 7.1 0 9.8l-2.7 2.7 0.6 1.3q1.3 2.4 2.1 5l0.4 1.3h3.9c1.8 0 3.6 0.7 4.9 2 1.3 1.3 2 3 2 4.9 0 3.7-3.1 6.8-6.9 6.8zm-11.8-6.8c0-4.9-1.9-9.6-5.2-13.2-3.3-3.5-7.7-5.7-12.6-6.1q-0.8-0.1-1.6-0.1c-10.6 0-19.3 8.7-19.3 19.4 0 10.6 8.7 19.3 19.3 19.3q0.8 0 1.6-0.1c4.9-0.4 9.3-2.5 12.6-6.1 3.3-3.6 5.2-8.3 5.2-13.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m784.4 608.8q-0.2 0.2-0.3 0.5c-1.3 3.5 0.5 7.6 4 8.9 3.6 1.4 7.6-0.4 9-3.9q0.1-0.3 0.1-0.6c1.1-3.4-0.8-7.1-4.1-8.4-3.3-1.3-7.2 0.2-8.7 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m802.1 594.4l-0.9 2.4 0.7 0.5q1.4 1.1 2.6 2.5l0.6 0.7 2.3-1.1c1.1-0.5 2.3-0.5 3.4-0.1 1.1 0.5 2 1.3 2.5 2.4 0.5 1.1 0.5 2.3 0.1 3.4-0.4 1.1-1.3 2-2.4 2.5l-2.3 1 0.1 0.9q0.2 1.8 0.1 3.6l-0.1 0.9 2.4 0.9c1.1 0.4 2 1.3 2.5 2.4 0.3 0.7 0.5 1.6 0.3 2.4v0.2q-0.1 0.4-0.2 0.8c-0.9 2.3-3.5 3.5-5.8 2.6l-2.4-1-0.6 0.8q-1 1.4-2.4 2.5l-0.7 0.6 1.1 2.4c0.4 1.1 0.5 2.3 0 3.4-0.4 1.1-1.2 2-2.3 2.5-2.3 1-4.9 0-5.9-2.3l-1.1-2.3-0.9 0.1q-1.7 0.2-3.5 0.1l-0.9-0.1-0.9 2.4c-0.5 1.1-1.3 2-2.4 2.5-1.1 0.5-2.3 0.5-3.4 0.1-2.3-0.9-3.5-3.5-2.6-5.8l0.9-2.4-0.7-0.6q-1.4-1.1-2.5-2.4l-0.6-0.7-2.4 1c-1.1 0.5-2.3 0.5-3.4 0.1-1.1-0.4-2-1.3-2.5-2.3-1-2.3 0-5 2.3-6l2.3-1-0.1-0.9q-0.2-1.8-0.1-3.5l0.1-0.9-2.4-1c-1.1-0.4-2-1.2-2.5-2.3-0.5-1.1-0.5-2.3-0.1-3.5q0.2-0.4 0.4-0.8c1.2-1.7 3.4-2.5 5.4-1.7l2.4 0.9 0.6-0.7q1.1-1.4 2.4-2.6l0.7-0.6-1.1-2.3c-0.4-1.1-0.5-2.3 0-3.4 0.4-1.2 1.2-2 2.3-2.5 2.3-1 4.9 0 5.9 2.2l1.1 2.4 0.9-0.1q1.7-0.2 3.5-0.1l0.9 0.1 0.9-2.4c0.5-1.2 1.3-2 2.4-2.5 1.1-0.5 2.3-0.5 3.4-0.1 2.3 0.9 3.5 3.5 2.6 5.8zm-7 5.6c-2.9-1.2-6.2-1.1-9.2 0-2.9 1.2-5.3 3.4-6.7 6.3q-0.2 0.4-0.4 0.9c-2.5 6.5 0.8 13.9 7.3 16.4 6.5 2.5 13.8-0.8 16.3-7.3q0.2-0.5 0.3-1c0.9-3 0.6-6.3-0.8-9.1-1.4-2.9-3.8-5.1-6.8-6.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginArt);
export default __webpack_public_path__ + "static/media/loginArt.148128df.svg";
export { ForwardRef as ReactComponent };